import {
  FormControl,
  FormControlProps,
  FormErrorMessage,
  FormLabel,
  FormLabelProps,
  Select,
} from "@chakra-ui/react";
import { FieldProps, getIn } from "formik";
import React from "react";

interface Props extends FieldProps {
  label: string;
  labelProps?: FormLabelProps;
  containerProps?: FormControlProps;
  options: any;
}

const ChakraDropdown: React.FC<Props> = ({
  field,
  form,
  label,
  labelProps,
  containerProps,
  options,
  ...props
}) => {
  const errorText =
    getIn(form.touched, field.name) && getIn(form.errors, field.name);

  return (
    <FormControl isInvalid={!!errorText} my="2" {...containerProps}>
      <FormLabel
        fontFamily="Lexend, sans-serif"
        color="gray.700"
        htmlFor={`${field.name}-id`}
        {...labelProps}
      >
        {label}
      </FormLabel>
      <Select fullWidth {...field} {...props}>
        {options.map((op: any) => (
          <option key={op.value} value={op.value}>
            {op.label}
          </option>
        ))}
      </Select>
      <FormErrorMessage>{errorText}</FormErrorMessage>
    </FormControl>
  );
};

export default ChakraDropdown;
